import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['startDate', 'endDate', 'shopCampaign'];

  // データ出力コードのフォームはモーダルを開いてから読み込まれるので、送信するときに出力条件を写す
  fill({ target }) {
    if (target.id !== 'csv_dl_form') return;

    target.querySelector('#start_date').value = this.startDateTarget.value;
    target.querySelector('#end_date').value = this.endDateTarget.value;

    const shopCampaignField = target.querySelector(
      '#selected_shop_campaign_id',
    );
    if (shopCampaignField && this.hasShopCampaignTarget) {
      shopCampaignField.value = this.shopCampaignTarget.value;
    }
  }
}
